import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import React from 'react';
import { Menu } from '@elliemae/ds-menu';

var ColumnsOptionsMenuSection = function ColumnsOptionsMenuSection(_ref) {
  var columns = _ref.columns,
      onColumnVisibilityChange = _ref.onColumnVisibilityChange,
      _ref$searchable = _ref.searchable,
      searchable = _ref$searchable === void 0 ? false : _ref$searchable,
      height = _ref.height;
  return function () {
    var _columns$reduce = columns.reduce(function (result, column, index) {
      return {
        items: [].concat(_toConsumableArray(result.items), [{
          id: column.property,
          label: column.label,
          checked: column.visible,
          onClick: function onClick() {
            return onColumnVisibilityChange(column, index);
          }
        }]),
        active: typeof column.visible === 'undefined' || column.visible ? [].concat(_toConsumableArray(result.active), [column.property]) : result.active
      };
    }, {
      items: [],
      active: []
    }),
        items = _columns$reduce.items,
        active = _columns$reduce.active;

    return /*#__PURE__*/React.createElement(Menu.SelectionGroup, {
      active: active,
      height: height,
      items: items,
      multi: true,
      searchable: searchable
    });
  };
};

export default ColumnsOptionsMenuSection;
//# sourceMappingURL=ColumnsOptionsMenuSection.js.map
